import React from 'react';
import { batch } from 'react-redux';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import landingPagesApi from 'services/api/landingPagesApi';
import { errorMessagesUtils } from 'services/utils';
import { duplicateLandingPageSuccess, requestDuplicateLandingPage } from '../actions/duplicateLandingPage';

export const successIndication = {
    type: INDICATION_TYPES.SUCCESS,
    message: (
        <FormattedMessage
            id="landing.pages.duplicate.success.updated"
            defaultMessage="Advertorial duplicated successfully"
        />
    ),
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = errorObject => ({
    type: INDICATION_TYPES.ERROR,
    message: errorMessagesUtils.getErrorMessage(errorObject),
    highlight: (
        <FormattedMessage id="landing.pages.duplicate.error.updated" defaultMessage="Unable to duplicate Advertorial" />
    ),
});

export const duplicateLandingPage =
    ({ accountName, landingPageId, title, status }) =>
    async dispatch => {
        dispatch(requestDuplicateLandingPage());

        try {
            const response = await landingPagesApi.duplicateLandingPage({ accountName, landingPageId, title, status });
            batch(() => {
                dispatch(duplicateLandingPageSuccess(response));
                dispatch(addIndication(successIndication));
            });
            return response;
        } catch (error) {
            // Only show the error indication, don't dispatch grid state error
            // since duplicate failures shouldn't affect existing landing pages
            dispatch(addIndication(generateErrorIndication(error)));
            throw error;
        }
    };
